import React from 'react';
import { BasketCard } from '../../BasketCard/BasketCard';

const BasketGrid = ({ baskets, selectedBasketId, onBasketSelect, currentBasketId, searchTerm, onBasketMenuClick }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 overflow-y-auto flex-grow">
    {baskets.map(basket => (
      <BasketCard
        key={basket.id || `temp-${Date.now()}`}
        basket={basket}
        onClick={() => onBasketSelect(basket.id)}
        onMenuClick={(basket, action) => onBasketMenuClick(basket, action)}
        searchTerm={searchTerm}
        isSelected={basket.id === selectedBasketId}
        isClickable={basket.id !== currentBasketId}
        isBSIComponent={true}
      />
    ))}
    {baskets.length === 0 && (
      <p className="col-span-full text-center text-gray-500 dark:text-gray-400">
        {searchTerm ? 'No baskets match your search.' : 'No baskets available.'}
      </p>
    )}
  </div>
);

export default BasketGrid;
